module.exports = __webpack_public_path__ + "static/media/30.bd9e817a.jpg";